export enum DateFormat {
  DMY_DASH = 'DD-MM-YYYY',
  YMD_DASH = 'YYYY-MM-DD',
  DMY_DOT = 'DD.MM.YYYY',
  MDY_SLASH = 'MM/DD/YYYY',
  dd_Mmm_YYYY = 'dd-MMM-YYYY',
}

export enum TimeFormat {
  HH_MM = 'HH:MM',
  HH_MM_AM = 'HH:MM AM/PM',
}
